import { tapEffect } from "./tap-effect.js";
import { createResourceFiber, unmountResourceFiber, renderResourceFiber, commitResourceFiber, } from "../core/ResourceFiber.js";
import { tapMemo } from "./tap-memo.js";
import { tapState } from "./tap-state.js";
import { tapConst } from "./tap-const.js";
export function tapResource(element, propsDeps) {
    const [version, setVersion] = tapState(0);
    const rerender = tapConst(() => () => setVersion((v) => v + 1), []);
    const fiber = tapMemo(() => {
        void element.key;
        return createResourceFiber(element.type, (callback) => {
            if (callback())
                rerender();
        });
    }, [element.type, element.key]);
    const result = propsDeps
        ? // biome-ignore lint/correctness/useExhaustiveDependencies: user provided deps instead of prop identity
            tapMemo(() => renderResourceFiber(fiber, element.props), [fiber, ...propsDeps, version])
        : renderResourceFiber(fiber, element.props);
    tapEffect(() => () => unmountResourceFiber(fiber), [fiber]);
    tapEffect(() => {
        commitResourceFiber(fiber, result);
    }, [fiber, result]);
    return result.output;
}
//# sourceMappingURL=tap-resource.js.map